import { PROFILE_ROUTE_NAMES } from '../../../../constants/route'

export function getUserProfileTabUrl({ tab, userId }) {
  return PROFILE_ROUTE_NAMES.userProfileNG({
    additionalParams: `/${tab}`,
    id: userId,
  })
}
